module.exports = __webpack_public_path__ + "img/pp.da61fe7d.png";